<template>
  <div class="flex w-full h-full" style="position: relative">
    <admin-mission-plan
      ref="editPlan"
      :uiid="missionPlanUiid"
      :enablePayload="false"
      :enableAdvencedNav="true"
      :hideAutoScale="true"
      @goto="goTo"
      @fit="fit"
    >
      <template v-slot:action>
        <v-card-actions class="pa-0 px-2 ma-0">
          <v-autocomplete
            :items="missionPlanTemplates"
            item-text="libelle"
            item-value="id"
            :label="$t('Pilot.MissionPlan.LoadFromTemplate')"
            v-model="templateId"
            class="ml-1"
            :append-outer-icon="templateId ? 'mdi-reload' : ''"
            @click:append-outer="loadFromTemplate()"
          ></v-autocomplete>
        </v-card-actions>
      </template>
    </admin-mission-plan>
  </div>
</template>
<script lang="ts">
import { ISmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import AdminMissionPlan from '@/components/admin/missionPlanTemplate/AdminMissionPlan.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import deepEqual from 'deep-equal'
import { Watch } from 'vue-property-decorator'
import { MapUiState } from '@/models/ui/MapUiState'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import {
  isAloDbMissionGlobalCoverage,
  isAloDbMissionGlobalFormation,
  isAloDbMissionGlobalSimulator,
} from '@/models/alodb/AloDbMissionGlobal'
import { CoverageStep } from '@/enum/CoverageStep'
import { CoverageState } from '@/enum/CoverageState'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'
import { AloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import { cloneDeep } from 'lodash'

@Component({
  name: 'FleetFormationMissionPlan',
  components: { AdminMissionPlan },
})
export default class FleetFormationMissionPlan extends Vue {
  created() {
    this.$store.myActions.MISSIONVIRTUAL_ENSURE_LIST()
    this.$store.myActions.COVERAGEITERATION_ENSURE_LIST()
    this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    //this.$store.myActions.MISSIONPLANTEMPLATE_ENSURE_LIST()
    this.missionPlanUiState.missionPlan = this.modified.config!.barycentre_mission_plan
    //this.plan = this.modified.config!.barycentre_mission_plan
  }

  get uistatebyuiid() {
    return this.$store.myGetters.uistatebyuiid
  }

  get mapState() {
    //retourne un MapUiState
    return this.uistatebyuiid(this.map_uiid) as MapUiState
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmAdminFleet as AloDbFleetFormation
  }

  get missionVirtualsById() {
    return this.$store.myGetters.missionVirtualsById
  }

  get endedCoverageIterations() {
    return this.$store.myGetters.coverageIterations.filter(
      ci =>
        ci.COV_PROCESSING_STEP == CoverageStep.FinalSimulation &&
        (ci.COV_PROCESSING_STATE == CoverageState.aborted || ci.COV_PROCESSING_STATE == CoverageState.finished),
    )
  }

  get maxEndedCoverageIterationIdByMigId() {
    return this.endedCoverageIterations.reduce((acc, it) => {
      if (!acc[it.MIG_ID!] || acc[it.MIG_ID!] < it.COV_ID!) acc[it.MIG_ID!] = it.COV_ID!
      return acc
    }, {} as { [key: number]: number })
  }

  get coverageIterationsById() {
    return this.$store.myGetters.coverageIterationsById
  }

  get original() {
    return this.$store.myGetters.originalAdmAdminFleet as AloDbFleetFormation
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.modified?.FLE_ID || -1, 'fleet')
  }

  get btnActif() {
    return !deepEqual(this.plan, this.original?.config!.barycentre_mission_plan)
  }

  get missionPlanUiState() {
    return this.$store.myGetters.missionPlanUiStateByUiid(this.missionPlanUiid)
  }

  get plan() {
    return this.missionPlanUiState.missionPlan
  }
  set plan(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
      uiid: this.missionPlanUiid,
      plan: value,
    })
  }

  // get missionPlanTemplates() {
  //   return this.$store.myGetters.missionPlanTemplates.filter(mt => (!this.isOperator && !this.isSysAdmin)  || this.selectedFilterEnsIds == undefined || mt.ENS_ID == this.selectedFilterEnsIds)
  // }

  get missionGlobals() {
    return this.$store.myGetters.missionGlobals.filter(
      m =>
        isAloDbMissionGlobalSimulator(m) &&
        //@ts-ignore
        ((!this.isOperator && !this.isSysAdmin) ||
          this.selectedFilterEnsIds == undefined ||
          m.ENS_ID == this.selectedFilterEnsIds),
    )
  }

  get missionPlanTemplates() {
    return this.missionGlobals
      .reduce((list, m) => {
        if (isAloDbMissionGlobalCoverage(m) || isAloDbMissionGlobalFormation(m)) {
          const maxCovId = this.maxEndedCoverageIterationIdByMigId[m.MIG_ID!]
          const covIteration =
            this.coverageIterationsById[(m.config?.templateSimId ?? 0) > 0 ? m.config!.templateSimId! : maxCovId]
          if (covIteration?.resultMipJson) {
            Object.keys(covIteration.resultMipJson)?.forEach(k => {
              list.push({
                id: `${m.MIG_ID!}_${k}`,
                libelle: `${m.MIG_LIBELLE} #${k}`,
                config: covIteration.resultMipJson![k],
              })
            })
          }
        } else {
          const maxVimId = Math.max(...m.misIdArray, -1)
          list.push({
            id: m.MIG_ID!.toString(),
            libelle: m.MIG_LIBELLE,
            config:
              (m.config?.templateSimId ?? 0) > 0
                ? this.missionVirtualsById[m.config!.templateSimId!]?.param ?? m.config
                : this.missionVirtualsById[maxVimId]?.param ?? m.config,
          })
        }
        return list
      }, [] as Array<{ id: string; libelle: string | null; config: ISmartSimulation }>)
      .filter(it => (it.config?.mission_plan?.steps?.length ?? 0) > 0)
  }

  loadFromTemplate() {
    if (this.templateId) {
      const templateConfig = this.missionPlanTemplates.find(m => m.id == this.templateId)
      if (templateConfig) {
        this.modified!.config.barycentre_mission_plan = cloneDeep(templateConfig.config!.mission_plan)
      }
      this.plan = this.modified!.config!.barycentre_mission_plan
      //@ts-ignore
      if (this.$refs.editPlan) this.$refs.editPlan.reset()
      this.templateId = null
      this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
    }
  }

  get isOperator() {
    return this.$store.myGetters.isOperator
  }

  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  get selectedFilterEnsIds() {
    //@ts-ignore
    return this.$store.myGetters.filterMission?.ensIds?.at(0) ?? undefined
  }

  templateId = null

  @Watch('modified')
  onModifiedModified() {
    if (!this.btnActif) {
      this.plan = this.modified.config!.barycentre_mission_plan
    }
  }

  get map_uiid() {
    return buildFleetUIStateId(this.original.FLE_ID!, 'map')
  }

  goTo(coordinate: Coordinate) {
    //console.log("coordinate",coordinate)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }

  fit(extent: Extent) {
    //console.log("extent",extent)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }
}
</script>
